import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const fromMKADTagManager = createRangeTagManager({
  jsonQueryKey: 'from_mcad_km',
  template: 'От МКАД: %s км',
  id: 'fromMKAD',
});
